import { render } from "./Entrepreneur.vue?vue&type=template&id=15431ef0"
import script from "./Entrepreneur.vue?vue&type=script&lang=js"
export * from "./Entrepreneur.vue?vue&type=script&lang=js"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__